<mat-card class="w-full">
  <mat-card-header class="">
    <div class="flex flex-row rounded-lg w-full" style="background-color:#5775a8; padding: 20px;">
      <mat-icon style="color: white;">settings</mat-icon>
      <span style="font-size: large; color: white;">
        Email Administration
      </span>
    </div>
  </mat-card-header>

  <mat-card-content class="flex justify-center items-center w-full">

    <div class="flex flex-col w-full items-center">
      <div class="flex flex-col w-11/12" *ngIf="showList">
        <hr style="border: 1px solid gray;">
        <div class="flex flex-row w-full">
          <div class="flex flex-row w-full">
           <span class="w-full">
            Click a County to modify the email address for that type of email.
           </span>
          </div>
          <div class="flex flex-row w-full justify-end">
            <input (keyup)="filterTable($event)" placeholder="Search" class="m-8" [value]="filter" />
          </div>
        </div>
        <hr style="border: 1px solid gray;">

        <div class="flex flex-row w-full">

          <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort" class="w-full">

            <ng-container matColumnDef="countyId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>County</th>
              <td mat-cell *matCellDef="let item"><a (click)="rowClick(item)">{{item.countyId}}</a></td>
            </ng-container>
            <ng-container matColumnDef="emailTypeDescription">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Email Type</th>
              <td mat-cell *matCellDef="let item">
                {{item.emailTypeDescription}}
              </td>
            </ng-container>
            <ng-container matColumnDef="emailTo">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Email Address</th>
              <td mat-cell *matCellDef="let item">{{item.emailTo}}</td>
            </ng-container>
            <ng-container matColumnDef="emailCc">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Carbon Copy (CC) Email Address</th>
                <td mat-cell *matCellDef="let item">{{item.emailCc}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>

          </table>
        </div>
        <!-- <mat-paginator [pageSizeOptions]="[5, 20, 100]" #TablePaginator="matPaginator"
          showFirstLastButtons></mat-paginator> -->
      </div>

      <div class="flex flex-col w-11/12" *ngIf="!showList">
        <form [formGroup]="form">
          <div class="flex flex-row rounded-lg w-full justify-evenly">
  
            <mat-form-field class="container">
              <mat-label>County</mat-label>
              <input matInput formControlName="countyId">
            </mat-form-field>
  
            <mat-form-field class="container">
              <mat-label>Email Type</mat-label>
              <input matInput formControlName="emailTypeDescription">
            </mat-form-field>
  
            <mat-form-field class="container">
              <mat-label>Email Address</mat-label>
              <input matInput formControlName="emailTo">
            </mat-form-field>
  
            <mat-form-field class="container">
              <mat-label>Carbon Copy (CC) Email Address</mat-label>
              <input matInput formControlName="emailCc">
            </mat-form-field>
  
            <div class="flex flex-row" style="align-items: flex-start;">
              <div style="padding-right: 20px;">
                <button mat-raised-button (click)="save()" class="m-8 container" style="background: #7ABDF3;">
                  Save
                </button>  
              </div>
              <div>
                <button mat-raised-button (click)="cancel()" class="m-8 container">
                  Cancel
                </button>  
              </div>
            </div>
  
          </div>
        </form>
  
      </div>
    </div>

  </mat-card-content>
</mat-card>